export const VoidTransactionValue = {
  WrongInputByUser: "Mischarged: Wrong Volume Input by User",
  WrongVolumeInput: "Mischarged: Wrong Volume Input (Tank Full before reaching Amount)",
  Others: "Others",
};

export default VoidTransactionValue;
